import React, { useContext } from "react";
import { RicosContext } from "./../../ricos-context/index.js";
import { useModalService } from "./../../ricos-modals/index.js";
import { DropdownModal } from "./../dropdown-modal/dropdown-modal.js";
import { ListItemDivider } from "./../list-item-divider/list-item-divider.js";
import { ListItemToggle } from "./../list-item-toggle/list-item-toggle.js";
import { SelectableOptionsList } from "./../selectable-options-list.js";
import { useNodeAttrs } from "./../use-node-attrs.js";
import { DEFAULT_OPTIONS, NODE_ALIGNMENT_BUTTONS, TEXT_WRAP_TOGGLE } from "./consts.js";
const NodeAlignmentDropdown = ({
  nodeId,
  nodeType,
  modalId,
  onClick,
  options: optionsOverride,
  onTextWrapToggle,
  isTextWrapDisabled
}) => {
  const { t, languageDir } = useContext(RicosContext);
  const modalService = useModalService();
  const attrs = useNodeAttrs(nodeId, nodeType);
  const alignment = attrs.pmNodeAttrs?.containerData?.alignment || getDefaultAlignment(languageDir);
  const textWrap = attrs.pmNodeAttrs?.containerData?.textWrap;
  const disableTextWrap = isTextWrapDisabled?.() || alignment === "CENTER";
  const alignmentOptions = (optionsOverride ?? DEFAULT_OPTIONS).map(
    (option) => NODE_ALIGNMENT_BUTTONS[option]
  );
  const AlignmentDropdownOptions = /* @__PURE__ */ React.createElement(
    SelectableOptionsList,
    {
      options: alignmentOptions.map((option) => ({
        value: option.commandKey,
        icon: option.icon,
        mobileIcon: option.iconSmall,
        wixelIcon: option.wixelIcon,
        dataHook: option.dataHook,
        text: option.text
      })),
      selectedId: alignment,
      onChange: (value) => onClick(value)
    }
  );
  return /* @__PURE__ */ React.createElement(
    DropdownModal,
    {
      onCloseButtonClick: () => modalService.closeModal(modalId),
      title: t("NodeAlignmentDropdown_Title"),
      options: optionsOverride?.length ? AlignmentDropdownOptions : (
        // prettier-ignore
        [
          AlignmentDropdownOptions,
          /* @__PURE__ */ React.createElement(ListItemDivider, { key: "divider" }),
          /* @__PURE__ */ React.createElement(
            TextWrapToggle,
            {
              key: TEXT_WRAP_TOGGLE.commandKey,
              onTextWrapToggle: onTextWrapToggle ?? (() => {
              }),
              textWrap,
              disableTextWrap,
              selectedAlignment: alignment
            }
          )
        ]
      )
    }
  );
};
const TextWrapToggle = ({ onTextWrapToggle, textWrap, disableTextWrap, selectedAlignment }) => {
  const { t } = useContext(RicosContext);
  return /* @__PURE__ */ React.createElement(
    ListItemToggle,
    {
      key: TEXT_WRAP_TOGGLE.commandKey,
      dataHook: TEXT_WRAP_TOGGLE.dataHook,
      onChange: onTextWrapToggle ?? (() => {
      }),
      title: t(TEXT_WRAP_TOGGLE.text),
      selected: disableTextWrap ? false : textWrap ?? true,
      infoContent: disableTextWrap ? t(
        selectedAlignment === "CENTER" ? TEXT_WRAP_TOGGLE.infoIconTextAlignedCenter : TEXT_WRAP_TOGGLE.infoIconTextUnsupportedContainer
      ) : void 0,
      disabled: disableTextWrap
    }
  );
};
const getDefaultAlignment = (langDir) => {
  return langDir === "rtl" ? "RIGHT" : "LEFT";
};
export {
  NodeAlignmentDropdown
};
//# sourceMappingURL=node-alignment-dropdown.js.map
